"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleStatus = void 0;
const types_1 = require("../../types");
exports.saleStatus = [
    {
        id: types_1.Vehicle.SaleStatusEnum.Any,
        name: 'Any',
        show: false,
    },
    {
        id: types_1.Vehicle.SaleStatusEnum.ForSale,
        name: 'For Sale',
        price_required: true,
        price_name: 'Listing Price',
        show: true,
    },
    {
        id: types_1.Vehicle.SaleStatusEnum.OpenToOffers,
        name: 'Open to Offers',
        price_required: false,
        show: true,
    },
    {
        id: types_1.Vehicle.SaleStatusEnum.NotForSale,
        name: 'Not for Sale',
        price_required: false,
        show: true,
    },
    {
        id: types_1.Vehicle.SaleStatusEnum.Sold,
        name: 'Sold',
        price_name: 'Sold Price',
        price_required: true,
        show: false,
    },
];
